<div id="profile-subheader" #profileSubHeader>
  <button mat-button color="primary" (click)="onClick()" class="btp-btn-md-txt subheader-link">
    <i class="icon ri-arrow-left-line"></i>
    <span *ngIf="actionText">{{ actionText }}</span>
    <span *ngIf="actionTranslation">
      <profile-translation [key]="actionTranslation"></profile-translation>
    </span>
  </button>
</div>
